import { Angulartics2GoogleTagManager } from 'angulartics2/gtm';
import { Injectable } from "@angular/core";
import { AnalyticsService } from './analytics.service';
import { Angulartics2 } from 'angulartics2';


@Injectable()
export class BrowserAnalyticsService extends AnalyticsService {


    constructor(angulartics2GoogleTagManager: Angulartics2GoogleTagManager,
                private angulartics2: Angulartics2
    ) {
        super();
        //Must inject component to activate gtm
    }

    eventTrack(tagName: string, extras: any) {
        this.angulartics2.eventTrack.next({
            properties: {
              event: tagName,
              gtmCustom: extras ? extras : undefined
            }
        });
    }
}